<template>
  <div class="posts">
    <span id="n-send">
      <PostsSendNotification
        v-if="showNotify"
        :post='notifyData'
        :clubs='clubs'
        @close="close"
      />
    </span>
    <va-card :title="$t('posts.title')">
      <div class="form-group">
        <va-select
          :label="$t('posts.forms.userLabel')"
          v-model="user"
          textBy="name"
          keyBy='id'
          no-clear
          searchable
          :placeholder="$t('posts.forms.userPlaceholder')"
          :noOptionsText="$t('posts.forms.userNoOption')"
          maxHeight='200px'
          :options="users"
        />
        <va-select
          :label="$t('posts.forms.clubLabel')"
          v-model="club"
          textBy="name"
          keyBy='id'
          no-clear
          searchable
          :placeholder="$t('posts.forms.clubPlaceholder')"
          :noOptionsText="$t('posts.forms.clubNoOption')"
          maxHeight='200px'
          :options="clubs.length > 0 ? clubs.filter(i => i.id !== -1) : []"
        />
      </div>
      <template slot="actions">
        <va-button :to="{ name: 'posts-add-update', params: { title: 'add' } }" icon="fa fa-plus"/>
      </template>
      <va-data-table
        :fields="fields"
        :data="posts"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('posts.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              :to="{ name: 'posts-add-update', params: { postId: props.rowData.id, title: 'update' } }"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.send')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              href="#n-send"
              icon="fa fa-send-o"
              @click="notify(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('posts.tooltips.link')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              target='_blank'
              :href="link + '/noticia/' + props.rowData.date.split('-')[0] + '/' + props.rowData.date.split('-')[1] + '/' + props.rowData.date.split('-')[2] + '/' + props.rowData.slug"
              icon="fa fa-share"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('posts.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deletingUpload"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import PostsSendNotification from './PostsSendNotification'
const perPage = 10
export default {
  name: 'posts',
  components: {
    PostsSendNotification,
  },
  data () {
    return {
      clubs: [],
      users: [],
      posts: [],
      user: '',
      club: '',
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showNotify: false,
      modalDeletar: false,
      deleteId: 0,
      notifyData: null,
      link: '',
    }
  },
  methods: {
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    notify (data) {
      this.notifyData = data
      this.showNotify = true
    },
    close (v) {
      this.showNotify = v
      this.notifyData = null
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.posts.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deletingUpload () {
      const self = this
      this.$axios.delete(
        '/api/upload',
        {
          data: {
            file: this.deleteId.image,
          },
        },
      ).then(resp => {
        self.deleting()
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_post_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  apollo: {
    clubs: {
      query: gql`
      query myquery {
        clubs: club(order_by: {name: asc}, where: {id: {_neq: 1}}) {
          id
          name
          code
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.clubs.length > 0) {
            const geral = {
              id: 0,
              name: 'Geral',
              code: 'geral',
            }
            const nEnviar = {
              id: -1,
              name: 'Não Enviar',
              code: 'naoenviar',
            }
            if (data.clubs[0].id !== geral.id && data.clubs[0].name !== geral.name) {
              data.clubs.unshift(nEnviar)
              data.clubs.unshift(geral)
            }
            this.clubs = data.clubs
            this.club = data.clubs[0]
          }
        }
      },
    },
    users: {
      query: gql`
      query myquery {
        users: user(
            order_by: {id: asc}
          ) {
          id
          name
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.users.length > 0) {
            const todos = {
              id: 0,
              name: 'Todos',
            }
            if (data.users[0].id !== todos.id && data.users[0].name !== todos.name) {
              data.users.unshift(todos)
            }
            this.users = data.users
            this.user = todos
          }
        }
      },
    },
    posts: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2, $where: post_bool_exp = {}) {
        posts: post(limit: $perPage, offset: $page, order_by: {id: desc}, where: $where) {
          id
          title
          subtitle
          created_at
          image
          slug
          exclusive
          image_credits
          user {
            name
          }
          club: post_clubs(where: {club_id: {_is_null: false}}) {
            club {
              id
              name
              code
            }
          }
          date
        }
      }
      `,
      variables () {
        const where = {}
        if (this.club.id !== 0) {
          where.club = {}
          where.club.id = {}
          where.club.id._eq = this.club.id
        }
        if (this.user.id !== 0) {
          where.user_id = {}
          where.user_id._eq = this.user.id
        }
        return {
          perPage,
          page: 0,
          where,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery($where: post_bool_exp = {}) {
        pages: post_aggregate(where: $where) {
          aggregate {
            count
          }
        }
      }
      `,
      variables () {
        const where = {}
        if (this.club.id !== 0) {
          where.club = {}
          where.club.id = {}
          where.club.id._eq = this.club.id
        }
        if (this.user.id !== 0) {
          where.user_id = {}
          where.user_id._eq = this.user.id
        }
        return {
          where,
        }
      },
    },
  },
  computed: {
    totalPages () {
      return this.pages != null && Object.keys(this.pages).includes('aggregate') ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      const moment = this.$moment
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'title',
        title: this.$t('posts.headings.title'),
        width: '25%',
      }, {
        name: 'created_at',
        title: this.$t('posts.headings.created_at'),
        width: '15%',
        callback (value) {
          return moment(value).format('DD/MM/YYYY [as] HH:mm:ss')
        },
      }, {
        name: 'user',
        title: this.$t('posts.headings.user'),
        width: '10%',
        callback (value) {
          return value.name
        },
      }, {
        name: 'club',
        title: this.$t('posts.headings.club'),
        width: '10%',
        callback (value) {
          return value.map(el => el.club.name).join()
        },
      }, {
        name: 'exclusive',
        title: this.$t('posts.headings.exclusive'),
        width: '7%',
        callback (value) {
          return value ? 'SIM' : 'NÃO'
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  watch: {
    club (value) {
      if (value.id !== 0) {
        if (Object.keys(this.$apollo.queries).includes('posts')) {
          this.$apollo.queries.pages.refetch()
          this.$apollo.queries.posts.refetch()
        }
      }
    },
  },
  mounted () {
    this.link = process.env.VUE_APP_LINK
    this.posts = []
    this.pages = []
    if (Object.keys(this.$apollo.queries).includes('posts')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.posts.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
